import db from '../../versa/db.js';

// Requires observer.js
export default function (...args)
{
	return {
		async actions(ev, publisher, customer_id)
		{
			if (!this.isEmpty())
				return;
			let company_id = this.locate('company_id').getValue();
			if (!company_id || company_id < 0 || !customer_id || customer_id < 0)
				return;
			let customer = await db.get('customers', [company_id, Number(customer_id)]);
			if (!customer || !customer['price_list_id'])
				return;
			let price_list = await db.get('price_lists', [company_id, customer['price_list_id']]);
			if (!price_list || !price_list['discount'])
				return;
			this.setValue(price_list['discount']);
			this.refresh();
		}
	};
}

